import { HttpBackend, HttpClient, HttpResponse } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { StorageKeys } from 'src/app/domain/enums/application/storage-keys.enum'
import { User } from 'src/app/domain/models/erp/administrator/user.model'
import { environment } from 'src/environments/environment'

const BOREAL_URL = environment.borealURL
const IPIFY_URL = 'https://api.ipify.org/?format=json'

@Injectable({ providedIn: 'root' })
export class UserRepositoryService {
  private httpClient: HttpClient = inject(HttpClient)
  public handler: HttpBackend = inject(HttpBackend)

  private httpClientExternal: HttpClient = new HttpClient(this.handler)

  public setAuthUser(authUser: User): void {
    localStorage.setItem(StorageKeys.KEY_LOGGED_USER, JSON.stringify(authUser))
  }

  public getAuthUser(): User {
    return !!localStorage.getItem(StorageKeys.KEY_LOGGED_USER) ? new User(JSON.parse(localStorage.getItem(StorageKeys.KEY_LOGGED_USER) as string)) : new User()
  }

  public getIPAddress(): Observable<HttpResponse<any>> {
    return this.httpClientExternal.get(`${IPIFY_URL}`, { observe: 'response' })
  }

  public getAuthUserPermissions(userId: number): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${BOREAL_URL}/auth-user/permissions/${userId}`, { observe: 'response' })
  }
}
